import PropTypes from 'prop-types';
import React from 'react';

import InputCheckbox from 'commons-forms/components/InputCheckbox/InputCheckbox.jsx';

class InputCheckboxContainer extends React.Component {
    constructor(props) {
        super(props);

        this.state = {};

        this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
    }

    handleCheckboxChange(value) {
        this.props.onChange(value, this.props.name);
    }

    render() {
        const options = this.props.options.map((option) => (
            <InputCheckbox
                {...option}
                valueChange={this.handleCheckboxChange}
                isSelected={option.isSelected ? option.isSelected : false}
                key={`${this.props.name}-${option.value}`}
            />
        ));

        return (
            <div className="checkbox-button-cta-wrapper">
                <div className="sr-text is-bold">{this.props.label}</div>
                {options}
            </div>
        );
    }
}

InputCheckboxContainer.defaultProps = {
    options: [],
};

InputCheckboxContainer.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    options: PropTypes.arrayOf(
        PropTypes.shape({
            isSelected: PropTypes.bool,
            label: PropTypes.node.isRequired,
            value: PropTypes.string.isRequired,
        })
    ),
};

InputCheckboxContainer.displayName = 'InputCheckboxContainer';

export default InputCheckboxContainer;
